import { nanoid } from "nanoid";
export { Connection };
class Connection {
    constructor({ id, ports, width, spacing, minBendradius, modifyLength, length }) {
        this.id = id !== null && id !== void 0 ? id : nanoid();
        this.ports = ports;
        this.width = width;
        this.spacing = spacing;
        this.minBendradius = minBendradius;
        this.modifyLength = modifyLength;
        this.length = length;
    }
}
//# sourceMappingURL=Connection.js.map